import React, { useMemo } from 'react';
import { FlexboxGrid, Stack, Text } from 'rsuite';
import { useSelector } from 'react-redux';
import {
  selectConfigExpressRegistrationMultiplePermitsPerAPNPolicy,
  selectConfigExpressRegistrationTypeVerbiage,
  selectConfigExpressParcelVerbiage,
} from '../../store/slices/config/configSelectors';
import { titleize } from '../../common/utils';
import { MULTIPLE_PERMITS_PER_APN_POLICY_OPTIONS_ENUM } from '../../common/enums';
import Notice from '../user-feedback/Notice';

const ApplyWarning = ({ details, isAdmin = false }) => {
  const selectedPermitTypeVerbiage = useSelector(
    selectConfigExpressRegistrationTypeVerbiage
  );
  const multipleLicenseStatus = useSelector(
    selectConfigExpressRegistrationMultiplePermitsPerAPNPolicy
  );
  const parcelVarbiage = useSelector(selectConfigExpressParcelVerbiage);

  const message = useMemo(() => {
    if (
      multipleLicenseStatus ===
      MULTIPLE_PERMITS_PER_APN_POLICY_OPTIONS_ENUM.WARN
    ) {
      return `This ${parcelVarbiage} already has existing ${selectedPermitTypeVerbiage?.toLowerCase()}s and/or applications. If you wish to create a new ${selectedPermitTypeVerbiage?.toLowerCase()} application anyway, then please click the continue button.`;
    } else {
      // block
      // admins can continue even if the config is set to block
      return isAdmin
        ? ` Regular users can not create a new ${selectedPermitTypeVerbiage?.toLowerCase()} application for this ${parcelVarbiage}. Due to your admin privileges you are able to continue.`
        : `You cannot create a new ${selectedPermitTypeVerbiage?.toLowerCase()} application for this ${parcelVarbiage} at this time. Please review the existing ${selectedPermitTypeVerbiage?.toLowerCase()}s and/or applications or contact support for further assistance.`;
    }
  }, [multipleLicenseStatus, selectedPermitTypeVerbiage, isAdmin]);

  const noticeType = useMemo(() => {
    if (
      multipleLicenseStatus ===
      MULTIPLE_PERMITS_PER_APN_POLICY_OPTIONS_ENUM.WARN
    ) {
      return 'warning';
    } else {
      return 'error';
    }
  }, [multipleLicenseStatus, selectedPermitTypeVerbiage]);

  return (
    multipleLicenseStatus !=
      MULTIPLE_PERMITS_PER_APN_POLICY_OPTIONS_ENUM.ALLOW && (
      <FlexboxGrid>
        <FlexboxGrid.Item colspan={24}>
          <Notice
            type={noticeType}
            message={message}
          />
        </FlexboxGrid.Item>

        <FlexboxGrid.Item>
          <Stack
            direction="column"
            alignItems="flex-start"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
            }}
          >
            {details?.map((detail, idx) => {
              return (
                <div
                  key={`existing_permit_${idx}`}
                  className="information-container mt-16 ph-24 pv-16"
                >
                  <Text className="mb-4 mt-4 text-large text-bold">
                    {titleize(detail.type || 'License')} {detail.permitNumber} -{' '}
                    {detail.registrantName}
                  </Text>
                  <Text className="mb-4">
                    {titleize(detail.propertyAddress)}
                  </Text>
                  {detail.expirationDate?.length > 0 ? (
                    <Text>Valid thru {detail.expirationDate}</Text>
                  ) : (
                    <Text>This license does not expire.</Text>
                  )}
                </div>
              );
            })}
          </Stack>
        </FlexboxGrid.Item>
      </FlexboxGrid>
    )
  );
};

export default ApplyWarning;
